import ReactJson from 'react-json-view'

export default function ItemsTableConsolePlain({data}) {
    return (
        <div className="itemsTableConsolePlain">
            {data}
        </div>
    )
}